import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({
  content,
  position = 'top',
  children
}) => (
  <div className="tooltip-wrapper">
    {children}
    <div className={`tooltip-box ${position}`}>
      {content}
      <div className={`tooltip-arrow ${position}`} />
    </div>
  </div>
);

Tooltip.propTypes = {
  content: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  children: PropTypes.node.isRequired,
};

export default Tooltip;
